import { useState } from 'react'
import { useNavigate, Link } from "react-router-dom";

import * as Yup from 'yup'
import clsx from 'clsx'

import {useFormik} from 'formik'
import {userRequestPassword} from '../../../auth/core/_requests'
import {useAuth} from '../../../auth/core/Auth'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string().trim()
    .email('Valid email required')
    .min(3, 'Minimum 3 symbols')
    .max(200)
    .required('Email is required'),
})

export function SetscoForgotPassword() {

  const navigate = useNavigate();
  const {saveAuth} = useAuth()

  const [ loading, setLoading ] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setSubmitting}) => {

      setSubmitting(true);
      setLoading(true);

      async function requestPassword() {
        await userRequestPassword(values.email)
        .then((res) => {
          saveAuth( {
            email: values.email,
            loggedIn: false,
            id: 0,
            password: '-forgot-',
          })
          navigate("/setsco/auth/forgot-password-otp");
        })
        .catch( (err) => {
          console.error(err);
        })
        .finally( ()=> {
          setSubmitting(false)                    
          setLoading(false);
        });
      }

      requestPassword();
    },
  })

  return (
  <>
  <form
    className='form w-100 bg-white rounded-4 fv-plugins-bootstrap5 fv-plugins-framework'
    noValidate
    id='kt_login_password_reset_form'
    onSubmit={formik.handleSubmit}
  >
    <div className="p-10 d-flex flex-column gap-4 mb-10">
      <div className='text-center mb-10'>
        <h1 className='text-dark fw-bolder mb-3'>Reset/Forgot Password ?</h1>
        <div className='text-gray-500 fw-semibold fs-6'>
          Enter your email to reset your password.
        </div>
      </div>
      
      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
        <input
          type='email'
          placeholder=''
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {'is-valid': formik.touched.email && !formik.errors.email,}
          )}
        />
        {formik.touched.email && formik.errors.email && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors.email}</span>
          </div>
        </div>
        )}
      </div>

      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button type='submit' id='kt_password_reset_submit' className='btn btn-info me-4'>
          <span className='indicator-label'>Submit</span>
          {loading && (
          <span className='indicator-progress'>
            Please wait...
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
          )}
        </button>
        <Link to='/setsco/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-secondary'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Cancel
          </button>
        </Link>
      </div>
    </div>
  </form>
  </>
  )
}
